import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import InnerHTML from "dangerously-set-html-content";
import Header from "../../../Header/Header";
import { Modal } from "react-bootstrap";
import "./PPQuizResult.css";
import { withAuth } from "../../../../app/util/HOC";
import { handleException } from "../../../../app/util/util";
import { ExpandCollapseControls } from "./ExpandCollapseControls";
export function PPQuizResult() {
  const history = useHistory();
  const { isbn, subtopictagid, subjectareatagid, quizinstanceid } = useParams();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [ppQrData, setPpQrData] = useState([]);
  const [ppQrLoading, setPpQrLoading] = useState(true);
  const [ppQrLoadPer, setPpQrLoadPer] = useState("0%");
  const [ppReTakeQuizPopUp, setPpReTakeQuizPopUp] = useState(false);
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  function fetchPpQuizResults() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          themisProductId: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          themisSubjectAreaId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          instanceId: quizinstanceid,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: subjectareatagid,
        },
        sessionVO: getSessionVO(),
      },
      ppQuizResultVO: { instanceId: quizinstanceid },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/managePP/getPPQuizStatusByInstanceId`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.ppQuizResultVO) {
            data.ppQuizResultVO = Array.isArray(data.ppQuizResultVO)
              ? data.ppQuizResultVO
              : [data.ppQuizResultVO];
            data.ppQuizResultVO.map((ppQrQuesVo) => {
              if (ppQrQuesVo.QPQuestionVOList) {
                ppQrQuesVo.QPQuestionVOList = Array.isArray(
                  ppQrQuesVo.QPQuestionVOList,
                )
                  ? ppQrQuesVo.QPQuestionVOList
                  : [ppQrQuesVo.QPQuestionVOList];
                ppQrQuesVo.QPQuestionVOList = ppQrQuesVo.QPQuestionVOList.map(
                  (previQues) => {
                    return { ...previQues, ques_expand_status: false };
                  },
                );
              }
            });
            setPpQrData(data.ppQuizResultVO);
          }
          setPpQrLoadPer("100%");
          setTimeout(() => {
            setPpQrLoading(false);
          }, 500);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useEffect(() => {
    fetchPpQuizResults();
  }, []);
  const handleBackToVideo = (quizType) => {
    if (quizType === "Video" || quizType === "video") {
      history.push(`/pp-video-library/${isbn}/video/${subtopictagid}`);
    } else {
      history.push(`/pp-quiz-center/${isbn}`);
    }
  };
  const handleGradedQuiz = (quizType) => {
    localStorage.removeItem("ppQuizInstances");
    if (quizType === "Video" || quizType === "video") {
      history.push(
        `/pp-quiz/graded/${isbn}/${subtopictagid}/${subjectareatagid}/video`,
      );
    } else {
      history.push(
        `/pp-quiz/graded/${isbn}/${subtopictagid}/${subjectareatagid}/${quizType}`,
      );
    }
  };
  function handlePpQrExpCollAll(quesExpandSt) {
    const newQuesExpandState = ppQrData.map((ppQrQuesVo) => {
      ppQrQuesVo.QPQuestionVOList.map((ppQrQues) => {
        ppQrQues.ques_expand_status = quesExpandSt;
      });
      return ppQrQuesVo;
    });
    setPpQrData(newQuesExpandState);
  }
  function handlePpQrQuesExpColl(quesIden, quesExpandSt) {
    const newQuesExpandState = ppQrData.map((ppQrQuesVo) => {
      ppQrQuesVo.QPQuestionVOList.map((ppQrQues) => {
        if (ppQrQues.questionIdentifier === quesIden) {
          ppQrQues.ques_expand_status = quesExpandSt;
        }
      });
      return ppQrQuesVo;
    });
    setPpQrData(newQuesExpandState);
  }
  return (
    <>
      <Header
        userVO={userVO}
        pageName="CCPracticePerfect"
        isbn={isbn}
        subtopictagid={subtopictagid}
        subjectareatagid={subjectareatagid}
        quizinstanceid={quizinstanceid}
      ></Header>
      <div>
        <div className="ppQrNotifiContainer">
          <div
            style={{ textAlign: "center" }}
            className="display-inline-block ppQrNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12"
          >
            PracticePerfect content is for personal use only. Redistribution is
            strictly prohibited. &copy; Aspen Publishing
          </div>
        </div>
      </div>
      {ppQrLoading === true ? (
        <Modal
          show={ppQrLoading}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <div className="ppQrLoad">
            <div className="ppQrLoadTxt">Loading your results...</div>
            <div className="progress ppQrLoadProgress">
              <div
                className="progress-bar ppQrLoadProgressBar"
                style={{ width: ppQrLoadPer }}
              ></div>
            </div>
          </div>
        </Modal>
      ) : (
        <div className="container">
          <div className="card ppQrContainerSection">
            <div className="card-body ppQrContainerCard">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                  <div className="ppQrLogoContainer">
                    <p>
                      <span className="ppQrCommonStyle ppQrLogoBoldText">
                        PracticePerfect<sup>TM</sup>
                      </span>
                      <span className="ppQrCommonStyle ppQrLogoText">
                        {localStorage.getItem("ppProductName") !== undefined &&
                          localStorage.getItem("ppProductName")}
                      </span>
                    </p>
                  </div>
                </div>
                {ppQrData.map((ppQrQuesData) => {
                  // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                  const isAllExpanded = ppQrQuesData.QPQuestionVOList.every(
                    (ppQrQues) => ppQrQues.ques_expand_status === true,
                  );
                  // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                  const isAllCollapsed = ppQrQuesData.QPQuestionVOList.every(
                    (ppQrQues) => ppQrQues.ques_expand_status === false,
                  );
                  return (
                    <>
                      <div className="ppQrQuizName col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding mt-3">
                        {ppQrQuesData.quizType === "Video" ||
                        ppQrQuesData.quizType === "video"
                          ? ppQrQuesData.customerFacingSubTopicName
                          : (ppQrQuesData.quizType.toLowerCase() ===
                              "summative a" ||
                            ppQrQuesData.quizType.toLowerCase() ===
                              "comparative1"
                              ? `Comparative Quiz A: Quiz `
                              : ppQrQuesData.quizType.toLowerCase() ===
                                    "summative b" ||
                                  ppQrQuesData.quizType.toLowerCase() ===
                                    "comparative2"
                                ? `Comparative Quiz B: Quiz `
                                : ppQrQuesData.quizType.toLowerCase() ===
                                    "comparative3"
                                  ? `Comparative Quiz C: Quiz `
                                  : ppQrQuesData.quizType.toLowerCase() ===
                                      "comparative4"
                                    ? `Comparative Quiz D: Quiz `
                                    : ppQrQuesData.quizType.toLowerCase() ===
                                          "cumulative" ||
                                        ppQrQuesData.quizType.toLowerCase() ===
                                          "cumulative2"
                                      ? `Comparative Quiz: All Topics: Quiz `
                                      : ppQrQuesData.quizType + ": Quiz ") +
                            ppQrQuesData.quizAttempt}
                      </div>
                      {ppQrQuesData.isGraded === false ||
                      ppQrQuesData.isGraded === "false" ? (
                        <>
                          <div className="ppQrQuizDesc col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding mt-1">
                            Quizzes taken in Practice Mode are not reflected on
                            your Progress Dashboard
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12 no-padding mt-2">
                            <button
                              className="ppQrVidoBackBtn"
                              onClick={() =>
                                handleBackToVideo(ppQrQuesData.quizType)
                              }
                            >
                              {ppQrQuesData.quizType === "Video" ||
                              ppQrQuesData.quizType === "video"
                                ? `Back to Video`
                                : `Back to Quiz Center`}
                            </button>
                            <button
                              className="ppQrQuizTakeBtn"
                              onClick={() =>
                                handleGradedQuiz(ppQrQuesData.quizType)
                              }
                            >
                              Take Graded Quiz
                            </button>
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12 ppQrAll mt-3">
                            <ExpandCollapseControls
                              onCollapseAll={() => {
                                handlePpQrExpCollAll(false);
                              }}
                              onExpandAll={() => {
                                handlePpQrExpCollAll(true);
                              }}
                              isAllExpanded={isAllExpanded} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                              isAllCollapsed={isAllCollapsed} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-xl-6 col-lg-4 col-md-4 col-sm-4 col-4 no-padding mt-2">
                            <p className="ppQrScore mt-3">Your Score:</p>
                            <span className="ppQrScoreTxt">
                              {Number(ppQrQuesData.score).toFixed(2) + "%"}
                            </span>
                          </div>
                          <div className="col-xl-6 col-lg-8 col-md-8 col-sm-8 col-8 no-padding ppQrAll mt-2">
                            <div className="mt-3">
                              {ppQrQuesData.quizType === "Video" ||
                              ppQrQuesData.quizType === "video" ? (
                                <>
                                  <button
                                    className="ppQrVidoBackBtn"
                                    onClick={() =>
                                      handleBackToVideo(ppQrQuesData.quizType)
                                    }
                                  >
                                    Back to Video
                                  </button>
                                  <button
                                    className="ppQrQuizTakeBtn"
                                    onClick={() => setPpReTakeQuizPopUp(true)}
                                  >
                                    Retake Graded Quiz
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="ppQrVidoBackBtn"
                                    onClick={() =>
                                      handleBackToVideo(ppQrQuesData.quizType)
                                    }
                                  >
                                    {" "}
                                    Back to Quiz Center
                                  </button>
                                </>
                              )}
                            </div>

                            <div
                              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ppQrAll no-padding"
                              style={{ marginTop: "31px" }}
                            >
                              <ExpandCollapseControls
                                onExpandAll={() => handlePpQrExpCollAll(true)}
                                onCollapseAll={() =>
                                  handlePpQrExpCollAll(false)
                                }
                                isAllExpanded={isAllExpanded} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                                isAllCollapsed={isAllCollapsed} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
                              />
                            </div>
                          </div>
                          <Modal
                            show={ppReTakeQuizPopUp}
                            size="sm"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <div className="ppQrReQuizPopUpTxt">
                              <p>
                                {" "}
                                Retaking this video quiz will erase the data
                                from your previous attempt.
                              </p>
                              <p>
                                {" "}
                                Are you sure you want to retake this quiz?{" "}
                              </p>
                            </div>
                            <div className="ppQrReQuizPopUpFooter">
                              <button
                                className="ppQrReQuizPopUpNoBtn mr-2"
                                onClick={() => setPpReTakeQuizPopUp(false)}
                              >
                                No, Go Back
                              </button>
                              <button
                                className="ppQrReQuizPopUpYesBtn"
                                onClick={() =>
                                  handleGradedQuiz(ppQrQuesData.quizType)
                                }
                              >
                                Yes, Retake
                              </button>
                            </div>
                          </Modal>
                        </>
                      )}
                      <div className="ppQrBorder col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"></div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                        {ppQrQuesData.QPQuestionVOList.map(
                          (ppQrQues, index) => {
                            return (
                              <>
                                <div
                                  className="ppQrDisplayBlock ppQrNumStyle col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 no-padding"
                                  style={
                                    ppQrQues.choiceId === "0"
                                      ? { background: "#F8B3B3" }
                                      : ppQrQues.correct === "true"
                                        ? { background: "#D5E8B1" }
                                        : { background: "#F8B3B3" }
                                  }
                                >
                                  {ppQrQues.choiceId === "0" ? (
                                    <>
                                      <i
                                        className="fas fa-times ppQrWrong"
                                        aria-hidden="true"
                                        style={{ marginLeft: "-12px" }}
                                      ></i>
                                      <span className="sr-only">Incorrect</span>
                                    </>
                                  ) : ppQrQues.correct === "true" ? (
                                    <>
                                      <i
                                        className="fas fa-check ppQrCheck"
                                        aria-hidden="true"
                                        style={{ marginLeft: "-15px" }}
                                      ></i>
                                      <span className="sr-only">Correct</span>
                                    </>
                                  ) : (
                                    <>
                                      <i
                                        className="fas fa-times ppQrWrong"
                                        aria-hidden="true"
                                        style={{ marginLeft: "-12px" }}
                                      ></i>
                                      <span className="sr-only">Incorrect</span>
                                    </>
                                  )}
                                </div>
                                <span
                                  className="ppQrNumIndex"
                                  style={
                                    index + 1 == 100
                                      ? { right: "49px" }
                                      : index + 1 < 10
                                        ? { right: "33px" }
                                        : { right: "41px" }
                                  }
                                >
                                  {index + 1}
                                </span>
                                <div className="ppQrBtnStyle col-xl-1 col-lg-1 col-md-1 col-sm-2 col-3 no-padding">
                                  <button
                                    type="button"
                                    className="ppQrExpCollBtn"
                                    aria-expanded={ppQrQues.ques_expand_status}
                                    aria-controls={`question-panel-${ppQrQues.questionIdentifier}`}
                                    onClick={() =>
                                      handlePpQrQuesExpColl(
                                        ppQrQues.questionIdentifier,
                                        ppQrQues.ques_expand_status === true
                                          ? false
                                          : true,
                                      )
                                    }
                                  >
                                    {ppQrQues.ques_expand_status === true
                                      ? "Collapse"
                                      : "Expand"}
                                  </button>
                                </div>
                                <div
                                  style={
                                    index + 1 < 10
                                      ? { paddingLeft: "10px" }
                                      : { paddingLeft: "0px" }
                                  }
                                  className="ppQrDisplayBlock ppQrTxtStyle col-xl-10 col-lg-9 col-md-9 col-sm-8 col-xs-12 pt-xl-0 pt-md-0 pt-lg-0 pt-2"
                                >
                                  <InnerHTML
                                    html={ppQrQues.promptText}
                                    className="ppQrTxtStylePara"
                                  />
                                  {ppQrQues.ques_expand_status === true ? (
                                    <div
                                      id={`question-panel-${ppQrQues.questionIdentifier}`}
                                      className="ppQrQuesDiv"
                                    >
                                      {ppQrQues.choiceVOList.map(
                                        (ppQrQuesOpt) => {
                                          return (
                                            <>
                                              <div className="col mb-2">
                                                <div
                                                  className="ppQrDisplayBlock ppQrQuesOptNumStyle col-xl-1 col-lg-2 col-md-2 col-sm-4 col-4"
                                                  style={
                                                    ppQrQues.choiceId === "0"
                                                      ? ppQrQuesOpt.correct ===
                                                        "true"
                                                        ? {
                                                            background:
                                                              "#D5E8B1",
                                                          }
                                                        : {
                                                            background:
                                                              "#FFFFFF",
                                                          }
                                                      : ppQrQues.choiceId ===
                                                          ppQrQuesOpt.choiceId
                                                        ? ppQrQuesOpt.correct ===
                                                          "true"
                                                          ? {
                                                              background:
                                                                "#D5E8B1",
                                                            }
                                                          : {
                                                              background:
                                                                "#F8B3B3",
                                                            }
                                                        : ppQrQuesOpt.correct ===
                                                            "true"
                                                          ? {
                                                              background:
                                                                "#D5E8B1",
                                                            }
                                                          : {
                                                              background:
                                                                "#FFFFFF",
                                                            }
                                                  }
                                                >
                                                  {ppQrQues.choiceId === "0" ? (
                                                    ppQrQuesOpt.correct ===
                                                    "true" ? (
                                                      <i className="fas fa-check ppQrOptCheck"></i>
                                                    ) : null
                                                  ) : ppQrQues.choiceId ===
                                                    ppQrQuesOpt.choiceId ? (
                                                    ppQrQuesOpt.correct ===
                                                    "true" ? (
                                                      <i className="fas fa-check ppQrOptCheck"></i>
                                                    ) : (
                                                      <i className="fas fa-times ppQrOptWrong"></i>
                                                    )
                                                  ) : ppQrQuesOpt.correct ===
                                                    "true" ? (
                                                    <i className="fas fa-check ppQrOptCheck"></i>
                                                  ) : null}
                                                </div>
                                                <span
                                                  className="ppQrQuesNumIndex"
                                                  style={{ right: "33px" }}
                                                >
                                                  {ppQrQuesOpt.label.replace(
                                                    /[\])}[{(]/g,
                                                    "",
                                                  )}
                                                </span>
                                                <div className="ppQrDisplayBlock ppQrQuesOptTxtStyle col-xl-10 col-lg-10 col-md-9 col-sm-8 col-8 no-padding">
                                                  <InnerHTML
                                                    html={
                                                      ppQrQuesOpt.answerText
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </>
                                          );
                                        },
                                      )}
                                      <div className="ppQrDisplayBlock col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                        <div className="ppQrRatiTitle">
                                          Rationale:
                                        </div>
                                        <div className="ppQrRatiCon">
                                          <InnerHTML
                                            html={ppQrQues.feedbackText}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                                <div className="ppQrBorder col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"></div>
                              </>
                            );
                          },
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default withAuth(PPQuizResult);
